export enum PlatformType {
  // React Native or Nodejs
  NonBrowser = 'nodejs',
  // MetaMask Mobile in-app browser
  MetaMaskMobileWebview = 'in-app-browser',
  // Desktop Browser
  DesktopWeb = 'web-desktop',
  // Mobile Browser
  MobileWeb = 'web-mobile',
  // ReactNative
  ReactNative = 'react-native',
}
